import Skeleton from "react-loading-skeleton";

import { Button } from "shared/ui/button";

export const TradeSkeleton = () => {
  return (
    <>
      <div className="flex flex-col px-2.5">
        <Skeleton borderRadius={24} height={110} />
        <Skeleton borderRadius={24} containerClassName="mt-1.5" height={140} />
        <Skeleton borderRadius={18} containerClassName="mt-6" height={60} />
      </div>
      <Button disabled variant="spearmint" className="mt-6.5 w-full" size="56">
        Deposit
      </Button>
    </>
  );
};
